import { Navigate, Outlet, useLocation } from 'react-router';
import { previewToken } from './previewToken';
import { useSession } from './SessionProvider';

/**
 * Nothing renders until the first session answer arrives. Redirecting during
 * that window signs people out on every refresh, which on this product means
 * asking for a new magic link to read a prompt they already paid for.
 */
export function RequireSession(): JSX.Element | null {
  const { session, loading } = useSession();
  const location = useLocation();

  if (loading) {
    return null;
  }

  // A local preview run stands in for a session. Compile-time gated, so this
  // branch does not exist in a production bundle.
  if (!session && !previewToken()) {
    return <Navigate to="/entrar" replace state={{ from: location.pathname }} />;
  }

  return <Outlet />;
}
